import React, { useMemo, useState } from 'react'
import { Badge, RecordList } from '../BusinessDetailReport/BusinessDetailReport'
import styles from '../BusinessDetailReport/BusinessDetailReport.module.scss'
import { buildOwnerUccs } from './ownerUccModel'

const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`

export default function OwnerUccFilings({ uccs, showSummary = true }) {
    const model = useMemo(() => buildOwnerUccs(uccs), [uccs])
    const [showEnded, setShowEnded] = useState(false)
    const { summary, active, ended } = model
    if (!model.rows.length) return <div className={styles.calmLine}>No UCC filings found.</div>
    return (
        <div className={styles.uccList}>
            {showSummary && (
                <div className={styles.inlineBadges}>
                    <Badge tone={summary.active ? 'watch' : 'neutral'}>
                        {summary.active ? `${summary.active} active · ${plural(summary.lenders, 'lender')}` : 'None active'}
                    </Badge>
                    {summary.receivables > 0 && <Badge tone='watch' dot>{summary.receivables} on receivables or all assets</Badge>}
                    {summary.recent > 0 && <Badge tone='watch'>{summary.recent} recent</Badge>}
                    {summary.ended > 0 && <Badge tone='neutral'>{summary.ended} terminated or lapsed</Badge>}
                </div>
            )}
            {active.length > 0 && <RecordList items={active} />}
            {ended.length > 0 && (
                <>
                    <div className={styles.listActions}>
                        <button type='button' className={styles.textButton} onClick={() => setShowEnded(v => !v)} aria-expanded={showEnded}>
                            {showEnded ? 'Hide terminated and lapsed' : `Show ${ended.length} terminated or lapsed`}
                        </button>
                    </div>
                    {showEnded && <RecordList items={ended} />}
                </>
            )}
        </div>
    )
}
